/* eslint-disable import/prefer-default-export */
import type { PostClientVerifyTokenResponse } from '../../types/verify';
import fetcher from '../../utils/fetcher';

export async function postClientVerifyToken(userId: string, token: string) {
  const res = await fetcher(
    `${process.env.REACT_APP_API_URL}/verify/client/token`,
    'POST',
    { userId, token },
    token,
  ) as PostClientVerifyTokenResponse;
  return res;
}
